<template>
	<span> Offerteaanvraag verstuurd </span>
</template>
